import type { statistics as en } from '@/i18n/locales/en/statistics';
import type { Translation } from '@/i18n/types';

export const statistics: Translation<typeof en> = {
  panelType: {
    series: 'Seriler',
    sessions: 'Oturumlar',
    availability: 'Kullanılabilirlik',
  },
  status: {
    forbidden: 'Bunu görmenize izin verilmiyor.',
    insufficientData:
      'Kimseyi tanımlamadan bu grubu gösterecek kadar veriye sahip yeterli kişi henüz yok.',
    noMetrics: 'Bu aralıkta metrik yok.',
    noData: 'Bu aralıkta veri yok.',
    noSessions: 'Bu aralıkta oturum yok.',
    noAvailability: 'Hiç veri kaydedilmedi.',
    loadFailed: 'Bu panel yüklenemedi: {{message}}',
  },
  target: {
    you: 'Siz',
    department: '{{name}} departmanı',
    company: '{{name}} şirketi',
  },
  table: {
    date: 'Tarih',
    type: 'Tür',
    duration: 'Süre',
    calories: 'Kalori',
    avgHeartRate: 'Ort. nabız',
    minutes: '{{count}} dk',
    metric: 'Metrik',
    source: 'Kaynak',
    first: 'İlk',
    last: 'Son',
    days: 'Gün',
  },
  detailLink: 'Ayrıntıları görüntüle',
  range: {
    last7Days: 'Son 7 gün',
    last30Days: 'Son 30 gün',
    last90Days: 'Son 90 gün',
    thisWeek: 'Bu hafta',
    thisMonth: 'Bu ay',
    custom: 'Özel…',
    from: 'Başlangıç',
    to: 'Bitiş',
  },
};
